import expireNotice from './expire-notice.vue'
export default expireNotice
